import { NgModule } from '@angular/core';
import { AuthService, GlobalMessageService } from '@spartacus/core';
import { CustomGlobalMessageService } from './global-message/global-message.service';
import { ProductDataSheetService } from './product/product-datasheet.service';
import { CustomAuthService } from './auth/auth.service';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
  providers: [
    { provide: AuthService, useClass: CustomAuthService },
    { provide: GlobalMessageService, useClass: CustomGlobalMessageService },
    ProductDataSheetService,
    DialogService,
  ],
})
export class CustomServicesModule {}
